var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("zjye"),
        visible: _vm.dialogVisible,
        width: "600px",
        "before-close": _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("yhzh"), prop: "uid" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { filterable: "", placeholder: _vm.$t("qxz") },
                  model: {
                    value: _vm.formValidate.uid,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "uid", $$v)
                    },
                    expression: "formValidate.uid",
                  },
                },
                _vm._l(_vm.userList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: {
                      label: item.account + "-" + item.nickname,
                      value: item.uid,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("zjlx"), prop: "direction" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("qxz") },
                  model: {
                    value: _vm.formValidate.direction,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "direction", $$v)
                    },
                    expression: "formValidate.direction",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("zengye"), value: "1" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: _vm.$t("jsye"), value: "2" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: _vm.$t("xtcz"), value: "0" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("zengJianje"), prop: "money" } },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: _vm.$t("qsrzengJianye") },
                model: {
                  value: _vm.formValidate.money,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "money", $$v)
                  },
                  expression: "formValidate.money",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("editReason"), prop: "remark" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("qsreditReason") },
                model: {
                  value: _vm.formValidate.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "remark", $$v)
                  },
                  expression: "formValidate.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }